import React from 'react';
import PropTypes from 'prop-types';

import './IconCalendarDay.scss';

const IconCalendarDay = (props) => {
  const { date, style } = props;

  return (
    <div className="IconCalendarDay" style={style}>
      <div className="IconCalendarDay__month">{moment(date).format('MMM')}</div>
      <div className="IconCalendarDay__day">{moment(date).format('D')}</div>
    </div>
  );
};

IconCalendarDay.propTypes = {
  date: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  style: PropTypes.shape({
    height: PropTypes.string,
    width: PropTypes.string,
    fontSize: PropTypes.string,
  }),
};

IconCalendarDay.defaultProps = {
  style: undefined,
};

IconCalendarDay.displayName = 'IconCalendarDay';
export default IconCalendarDay;
